import React, { useEffect, useState } from 'react'
import { useFetchSimilarAnswersQuery } from '../../../../../../../../../store/apis/submission.api'
import { Button, Flex, List } from 'antd'
import SimpleTextViewer from '../../../../../../../../../components/common/text-viewer/SimpleTextViewer'
import Text from 'antd/es/typography/Text'
import PatternIcon from '../../../../../../../../../components/common/PatternIcon'
import useRubricContext from '../../../../../../../../../hooks/useRubricContext'

const useOffset = (dependencies = []) => {
    const [offset, setOffset] = useState(0)

    useEffect(() => {
        setOffset(0)
    }, dependencies)

    const incrementOffset = (incrementBy = 3) => {
        setOffset(prevOffset => prevOffset + incrementBy)
    }

    return [offset, incrementOffset]
}

const SimilarAnswers = ({ answer, questionRubric }) => {
    const questionRubricId = questionRubric?.id || answer?.questionRubricId
    const [offset, incrementOffset] = useOffset([answer?.id, questionRubricId])
    const { data: similarAnswers, isFetching: isFetchingSimilarSubmissions } = useFetchSimilarAnswersQuery({
        id: answer?.id,
        questionRubricId,
        offset,
    })
    
    const { categories } = useRubricContext({ questionRubricId })

    const onLoadMore = () => incrementOffset()

    const loadMore = !isFetchingSimilarSubmissions ? (
        <Flex justify='center' className='f-width mt-8'>
            <Button onClick={onLoadMore}>Load More</Button>
        </Flex>
    ) : null

    return (
        <List
            dataSource={similarAnswers}
            loadMore={loadMore}
            style={{ maxHeight: 400, overflow: 'auto' }}
            loading={{ spinning: isFetchingSimilarSubmissions, tip: 'Loading similar answers...' }}
            renderItem={answer => {
                const category = categories?.find(category => category.id === answer.categoryId)
                return (
                    <List.Item>
                        <List.Item.Meta
                            description={
                                <SimpleTextViewer
                                    value={answer.text}
                                    title={
                                        <Flex justify='space-between'>
                                            <Text type='secondary' submission-name={answer.name}>
                                                <PatternIcon
                                                    id={answer.categoryId}
                                                    colorId={category?.colorId}
                                                    showId={false}
                                                />{' '}
                                                {category?.name}{', Name: '}{answer.name}
                                            </Text>
                                            <Text type='secondary'>
                                                Similarity score: {Math.round(answer.confidence * 100)}%
                                            </Text>
                                        </Flex>
                                    }
                                    showActions={false}
                                    wrapperStyles={{ height: '100%' }}
                                />
                            }
                        />
                    </List.Item>
                )
            }}
        />
    )
}

export default SimilarAnswers
